const Form016EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },

    // for form 31A content
    tooltip: {
        tip1_t: "Note 2:",
        tip1: "The data collected below is used for payment of the retention incentive to the NET. The provision of information is obligatory. The information collected may be disclosed to other government departments/agencies authorized to process personal data for audit and statistical purposes.",

        tip2_t: "Note",
        tip2: "The eligibility of a NET for the retention incentive is subject to the school management's satisfaction with the performance of the NET, as reflected in the annual performance appraisal and the willingness of the school to retain his / her service throughout the remaining contract period or to renew the contract with the NET.",

        tip3_t: "Note:",
        tip3: "The school is required to complete ",
        tip3_b: "both",
        tip3_end:
            ' periods if the NET is eligible for both the 5% and 10% retention incentive at different periods in the current school year. Please read <a href="{{link}}" target="_blank" rel="noopener noreferrer">Examples</a> <u>before</u> completing this part.',
        partTwoTips1:
            "(For <u>aided schools</u>, please complete this part and forward the application form (Parts I - IV) to the NET Administration Team for action)",
        partTwoTips2:
            "(For <u>caput schools</u>, please complete this part and send a copy of the application form (Parts I - II) to the NET Administration Team <u>and</u> the respective Senior School Development Officer for record)",
    },
    importantNotesContent: {
        title: "Important Note",
        note1: "For Schools and NETs:",
        note2: "1. All eligible NETs are required to apply for the retention incentive ",
        note2_b1: "each school year",
        note2_1: " and complete ",
        note2_b2: "Part I",
        note2_2: " of this form.",

        note3: "2. Under the NET Schemes, the retention incentive is payable to the NET each school year (i.e. after he/she already has completed at least two years of continuous service in the NET Schemes when applying for the retention incentive) subject to the school management's confirmation in the annual appraisal that the performance of the NET is satisfactory.  However, the exact end date for payment of the retention incentive to a NET depends on his/her current contractual terms under the NET Schemes.  If his/her current contract ends on 15 August or 31 August, the payment of the retention incentive should cease on 15 August or 31 August respectively.  Applications by NETs for the retention incentive shall be made ",
        note3_b1: "each school year",
        note3_1:
            " through their schools.  Schools should remind their NETs to apply for the retention incentive before the start of each school year.",
        note4: "Reference Materials:",
        note5: 'EDB Circular No.{{circularNo}} on "Retention Incentive for Native-speaking English Teachers (NETs) under the Enhanced NET Scheme in Secondary Schools / NET Scheme in Primary Schools" ',
        note6: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/EDBC13002E.pdf",
        note7: '"Sample Memorandum on the Terms and Conditions of Service for Appointment as Teachers under the NET Scheme in Primary Schools / the Enhanced NET Scheme in Secondary Schools (applicable to {{schoolYear}} school year)"',
        note8_1: "Primary Schools:",
        note8_2:
            "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/MOCS_201920_Primary%20Schools.pdf",
        note9_1: "Secondary Schools:",
        note9_2:
            "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/MOCS_201920_Secondary%20Schools.pdf",
    },

    applicationInformationContent: {
        label: {
            // form 031A
            part2: "Part II",
            schoolName: "School Name",
            contactPersonTitle: "Contact Person Title",
            contactPerson: "Contact Person",
            schoolCode: "School Code",
            hkid: "Hong Kong Identity (HKID) Card Number",
            faxNo: "Fax No.",

            note1: "I certify that the information in Part I is correct.",
            note2: "Performance of ",
            note2_b: "(Full Name of the NET)",
            note3: "Taking into account the NET's performance or conduct throughout his / her previous and existing service period(s), I ",
            note3Option: {
                yes: "recommend",
                no: "do not recommend",
            },

            note4: "the grant of the retention incentive to the NET.",

            note5: "I confirm that the above NET has been continuously employed as a NET under the Enhanced NET Scheme in Secondary Schools/NET Scheme in Primary Schools for:",
            note5Option: {
                h24: "24 or more but less than 48 calendar months",
                h48: "48 calendar months or more",
            },

            note6: "The above mentioned NET is eligible to receive the retention incentive at the rate of:",
            note6Option: {
                h24: "5% for those with 2 years' (24 calendar months) or more but less than 4 years' (48 calendar months) continuous service under the NET Schemes.",
                h48: "10% for those with 4 years' (48 calendar months) or more continuous service under the NET Schemes.",
            },

            dateFrom: "for the period from",
            dateTo: "to",

            part2Declare1:
                "(a) I certify that the above information in Parts I and II is correct.",
            part2Declare2:
                "(b) I undertake to inform the Funds Section via the NET Administration Team of the Education Bureau as soon as possible if there is any change in the information provided above and to repay the Government for any overpayment of the retention incentive to the NET concerned.",
            part2Declare3:
                "(c) I undertake to inform the Funds Section of the Education Bureau immediately to claw back the paid retention incentive if the NET tenders his/her resignation from this school or is dismissed by this school.",

            // form 031
            title: "Title",
            titleOption: {
                mr: "Mr.",
                ms: "Ms.",
                mrs: "Mrs.",
                miss: "Miss",
            },
            aidedOrCaputOption: {
                aided: "Aided Schools",
                caput: "Caput Schools",
            },
            name: "Name (The name should be identical with that shown on the applicant's HKID Card)",
            nameOfSchool: "Name of the School",
            nameOfSchoolNow: "Name of the School (i.e. employer) now serving",
            telNo: "Tel. No.",
            schoolContractTitle: "My current contract with the school:",
            dateOfCommence: "Date of Commencement of Contract",
            dateOfComplete: "Date of Completion of Contract",
            teachExperience:
                "My previous teaching experience in Hong Kong under the NET Schemes",
            teachExperience2: "*Please complete in <u>chronological order</u>",
            teachExperienceTips:
                '<b><i>Please read <a href="{{link}}" target="_blank" rel="noopener noreferrer">Example 1</a> <u>before</u> completing this part</i></b>',
            gratuity: "Did you receive contract gratuity?",
            gratuityOption: {
                yes: "Yes",
                no: "No",
            },
            formTitle: "Application Information",
            part1: "Part I (To be completed and signed by the NET)",
            declare1:
                "wish to apply for the retention incentive under the Enhanced NET Scheme in Secondary Schools/NET Scheme in Primary Schools in the",
            declare2: "I agree to abide by the following conditions:",

            schoolYear: "school year",

            // form 016 (for reference)

            nameOfApplicationEn:
                "Name of Applicant (must be identical with that of the applicant's HK Identity Card)(English)",
            nameOfApplicationCh:
                "Name of Applicant (must be identical with that of the applicant's HK Identity Card)(Chinese, if applicable)",
            sex: "Sex",
            sexOption: {
                male: "Male",
                female: "Female",
            },
            mailingAddress: "Correspondence Address",
            schoolOrOffice: "School / Office",
            schoolOrOfficeOption: {
                school: "School",
                office: "Office",
            },
            workTel: "Contact Telephone No.",
            homeOrMobile: "Home / Mobile",
            homeOrMobileOption: {
                home: "Home",
                mobile: "Mobile",
            },
            privateTel: "Contact Telephone No.",
            fax: "Fax No.",
            email: "E-mail Address",
            hkidOrPassport: "HK Identity Card / Passport No",
            hkidOrPassportOption: {
                hkid: "HK Identity Card",
                passportNo: "Passport No",
            },
            // hkid: "HK Identity Card",
            passportNo: "Passport No",
            rtOrPt: "Registered Teacher / Permitted Teacher",
            rtOrPtOption: {
                rtNo: "Registered Teacher",
                ptNo: "Permitted Teacher",
            },
            rtNo: "Registered Teacher No.",
            ptNo: "Permitted Teacher No.",
            schoolOrOrganisation: "Applicant's School / Organisation",
            schoolOrOrganisationOption: {
                school: "Applicant's School",
                organisation: "Applicant's Organisation",
            },
            // schoolName: " Name",
            schoolAddress: " Address",
            schoolType: "Type of School (if applicable)",
            aidedOrCaput: "School Type",
            schoolTypeOption: {
                primary: "Primary",
                secondary: "Secondary",
                special: "Special",
                government: "Government",
                aided: "Aided",
                dss: "DSS",
                others: "Others",
            },
            otherSchoolType: "Others (Please specify)",
            certificationTitle: "Professional Qualification(s)",
            certificationName:
                "Teacher Training (e.g. a local Teacher's Certificate or Post-graduate Diploma / Certificate in Education or Bachelor of Education degree or equivalent)",
            awardingInstituteName: "Name of Awarding Institute:",
            awardDate: "Date(s) of Award",
            teachingExperience: "Teaching Experience",
            teachingExperienceOption: {
                five: "5 Years",
                ten: "6-10Years",
                fifteen: "10-15 Years",
                overFifteen: "over 15 Years",
            },
            curSchoolOrOrganisation:
                "Current Position in School / Organisation",
            curSchoolOrOrganisationOption: {
                schoolPost: "School",
                organisationPost: "Organisation",
            },
            schoolPost: "Current Position in School",
            organisationPost: "Current Position in Organisation",
            completeDate: "Needs Analysis Completion Date",
            commencementDate:
                "Preparation for Principalship Course Commencement Date",
            courseAwardDate:
                "Preparation for Principalship Course Date of Award",

            isDeclarationTitle: "Declaration",
            declarationP1: "I declare,",
            declarationContentList: [
                "1. that I have read and understood the Guidelines on Professional Development Portfolio for Aspiring Principals (Annex A);",
                "2. that the personal data entered in my application form and all the factual information contained in my professional development portfolio for this application are true and accurate;",
                "3. that the action research project mentioned in my professional development portfolio is the one I did in the Preparation for Principalship Course; and",
                "4. that the professional development portfolio is entirely my own work except where I have duly acknowledged other sources and put the copied parts in quotations in the portfolio. The professional development portfolio is in compliance with the copyright laws.",
            ],
        },
        errorMsg: {
            // Form 031A
            atLeastOne: "Please check at least one of the option",
            fivePercentCheck: "five percent check",
            tenPercentCheck: "ten percent check",

            nameOfApplicationEn: "name of applicant in English",
            nameOfApplicationCh: "name of applicant in Chinese",
            schoolName: "school name",
        },
        serial: {
            note1: "(i)",
            note2: "(ii)",
            note3: "(iii)",
            note4: "(iv)",
            note5: "(v)",
            note6: "(vi)",
            note7: "(vii)",
            note8: "(viii)",
            note9: "(ix)",
            note10: "(x)",
            note11: "(xi)",
            note12: "(xii)",
            note13: "(xiii)",
        },
        declaration: {
            note1: "I confirm that the information provided in this application, its attachment (if  applicable) and any other documents submitted or to be submitted are true and complete;",
            note2: "I have read all the details of the Education Bureau Circular No.{{circularNo}}, and I fully understand the content, requirements and declaration of this application;",
            note3: "I understand that if I make any false statements, provide any false or  misleading information, omit any relevant information, or change or alter this form in any unauthorized manner, my application may be declined or the approval granted may later be revoked. I understand that it is an offence to provide false information and may be liable to disciplinary / legal action;",
            note4: "I consent to the Government of the Hong Kong Special Administrative Region making any necessary enquiries for the verification of the information given above. I authorize all government departments and other organizations or agencies to release any relevant record or information as may be required in relation to such enquiries;",
            note5: "I understand and accept that the information given above will be provided to government departments and other organizations or agencies authorized to process the information for the purposes relating to the application for the retention incentive under the NET Schemes;",
            note6: "I understand that if my service is terminated by the School for reasons other than unsatisfactory performance or  conduct, I will be paid a retention incentive for the period of service completed, including school holidays taken within the period of service. Specifically, the retention incentive will be granted only if my School(s) [i.e. employer(s)] is/are satisfied with my performance or conduct during the period of service;",
            note7: "I agree that my School (i.e.  employer) could withhold the grant of the retention incentive if I were subject to  any disciplinary or criminal proceedings or investigation into any acts which may affect the grant of the retention incentive. If I were finally convicted of any criminal offences, the cumulative incentive paid for the months after having committed the offences would be clawed back;",

            note8: "I agree that if I resign or am dismissed, or my service is terminated for reasons of unsatisfactory performance or conduct, I will not be eligible to apply for the retention incentive. Where premature resolution or termination of contract is  initiated by me, the cumulative incentive paid for the months prior to the effective date of resignation in that school year will be clawed back. Where premature resolution or termination of contract is initiated by the school because of unsatisfactory performance or conduct, the cumulative incentive paid for the months in that school year after having received a written warning will be clawed back;",

            note9: "I hereby undertake to pay back the retention incentive under (vii) and (viii) above;",
            note10: "I  understand  that  the  retention  incentive  is  not  counted  as  base  salary  which  will  attract gratuity;",
            note11: "I understand that the retention incentive is taxable;",

            note12: "I agree that in circumstances where a retention incentive is paid to me in the mistaken belief that I have:",
            note12_a:
                "(a) satisfactorily completed my Contract and my obligations there under; or",
            note12_b:
                "(b) not been convicted of any offence that if determined on its own fact, would have led to the dismissal from the service during and in respect of my employment with the School(s) [i.e. employer(s)]",
            note12_end:
                "the School(s) shall be entitled, without affecting its other rights, to recover from me the whole or part of the retention incentive commensurate with all the circumstances of the case including the unsatisfactory nature of my service and  the seriousness of the offence on my part. Such right of the School shall survive the cessation of the Contract; and",

            note13: "I have read, understood and accept all of the conditions contained in this declaration.",
        },
    },
};
export default Form016EN;
